import { isServiceWorkerSupported } from '@/utils/serviceWorkerSupport';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage, type Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || 'AIzaSyALf-olUE7ynyHlvg7AuUAD4MYRMbtqQE8',
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || 'amigo-masp.firebaseapp.com',
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'amigo-masp',
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || 'amigo-masp.firebasestorage.app',
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '250117340684',
  appId:
    process.env.NEXT_PUBLIC_FIREBASE_APP_ID_WEB ||
    process.env.NEXT_PUBLIC_FIREBASE_APP_ID ||
    '1:250117340684:web:015989888d4c48a11e3829',
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || 'G-FG7J6447G7',
};

let messagingPromise: Promise<Messaging | null> | null = null;

// getMessaging() checa o suporte do browser de forma assíncrona e lança o erro dentro de uma promise
// própria, fora do alcance de qualquer try/catch em volta da chamada. Em browser sem suporte isso vira
// rejeição não tratada. isSupported() dá o mesmo veredito de um jeito que dá para esperar.
export const getMessagingIfSupported = (): Promise<Messaging | null> => {
  if (typeof window === 'undefined') return Promise.resolve(null);

  if (!messagingPromise) {
    messagingPromise = (async () => {
      // O SDK acessa navigator.serviceWorker.addEventListener por dentro, e em navegador in-app a
      // propriedade existe mas vem undefined.
      if (!isServiceWorkerSupported()) return null;

      const supported = await isSupported().catch(() => false);
      if (!supported) return null;

      try {
        return getMessaging(initializeApp(firebaseConfig));
      } catch (error) {
        console.warn('[Firebase] Failed to initialize messaging:', error);
        return null;
      }
    })();
  }

  return messagingPromise;
};

export { getToken, onMessage };
